import Rules from "./rules";

export default Rules;
